var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVectorTop2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 222,
    height: 295,
    viewBox: "0 0 222 295",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-46.6973 -228C98.3557 -228 215.803 -112.188 215.803 30.5C215.803 173.188 98.3557 289 -46.6973 289C-191.75 289 -309.197 173.188 -309.197 30.5C-309.197 -112.188 -191.75 -228 -46.6973 -228Z",
    stroke: "white",
    strokeWidth: 11
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorTop2);
export default __webpack_public_path__ + "static/media/vector-top-2.3413b2fed7d2426d2acfac794585ffb1.svg";
export { ForwardRef as ReactComponent };